// extracted by mini-css-extract-plugin
export default {"container":"NavBar_container__YuZWp","botones":"NavBar_botones__vk1dx","links":"NavBar_links__nUpHk","selectedLink":"NavBar_selectedLink__FSKU2","lenguaje":"NavBar_lenguaje__K9zj6"};